import { render, staticRenderFns } from "./editAddFieldModal.vue?vue&type=template&id=2aa23996&"
import script from "./editAddFieldModal.vue?vue&type=script&lang=js&"
export * from "./editAddFieldModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports